"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentIds = void 0;
var SegmentIds;
(function (SegmentIds) {
    SegmentIds["petSpecies"] = "c66217a3bd93998013d09bd";
    SegmentIds["petAge"] = "c66217a3bf8d8a2de2868f";
    SegmentIds["appointmentDate"] = "c66217a3b9a3df8d261675c";
    SegmentIds["appointmentType"] = "ekm0bf39a45bd884815bc5bny";
    SegmentIds["belongsToClinicAndIsActive"] = "c66217a3b5051c146447744";
    SegmentIds["hasAnEmail"] = "c66217a3ba0e9ec0ababaad";
    SegmentIds["hasActivePets"] = "c66217a3b4093f5088ca444";
    SegmentIds["hasAppointmentsWithin3Years"] = "c66217a3b13d68fbcff904d";
})(SegmentIds = exports.SegmentIds || (exports.SegmentIds = {}));
//# sourceMappingURL=SegmentIds.js.map